var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import styled from 'styled-components';
export var ModalContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\nposition: fixed;\ntop: 0;\nright: 0;\nbottom: 0;\npadding: ", ";\nwidth: ", ";\nbackground-color: #F9F9F9;\nbox-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\nz-index: 9999;\noverflow: auto;\n"])), function (props) {
  return !props.isMobile && '16px';
}, function (props) {
  return props.isMobile ? '100%' : '40%';
});
export var CloseButton = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\nbackground-color: transparent;\ncursor: pointer;\nborder-style: none;\nheight: ", ";\n"])), function (props) {
  return props.isMobile && '24px';
});
export var Content = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 700px) {\n    margin-left: 8px;\n    margin-right: 8px;\n    -webkit-overflow-scrolling: touch;\n    scroll-behavior: smooth;\n  }\n"])));
export var ModalBackdrop = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\nposition: fixed;\ntop: 0;\nright: 0;\nbottom: 0;\nleft: 0;\nbackground-color: rgba(0, 0, 0, 0.5);\nz-index: 9998;\n"])));
export var CardsContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\ndisplay: flex;\nflex-direction: column;\nalign-items: flex-start;\ngap: var(--spacing-2, 16px);\nmargin-top: var(--spacing-2, 16px);\n"])));
export var AlertBoxWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\nmargin: ", ";\n"])), function (props) {
  return props.isMobile && '16px';
});